<template>
  <div>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': [10, 20, 50]
      }"
      :headers="headers"
      :items="items"
      :loading="loading"
      :server-items-length="totalCount"
      :items-per-page="itemsPerPage"
      @update:page="val => updatePagination('page', val)"
      @update:items-per-page="val => updatePagination('itemsPerPage', val)"
      disable-sort
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td colspan="1">
            <SmallSelect
              :style="{ 'max-width': '150px' }"
              ref="producerSelect"
              placeholder="Chọn NSX"
              entity="producers"
              @changeSelect="
                val => {
                  filter.id = val
                  searchWithOption()
                }
              "
            />
          </td>
          <td></td>
          <td>
            <StatusSelect
              :style="{ 'max-width': '300px' }"
              :items="autoConfigItems"
              placeholder="Cấu hình"
              @onChangeStatus="
                val => {
                  filter.autoConfig = val
                  searchWithOption()
                }
              "
            />
          </td>
          <td>
            <SelectDate entity="updatedAt" @changeDate="val => searchWithOption({ ...val })" />
          </td>
          <td></td>
        </tr>
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ formatDateDDMMYYYY(item.updatedAt) }}
      </template>
      <template v-slot:[`item.autoConfig`]="{ item }">
        <div :class="{ 'error--text': !item.autoConfig }">
          {{ handlerAutoConfig(item.autoConfig) }}
        </div>
      </template>
      <template v-slot:[`item.name_short`]="{ item }">
        {{ `${item.name_short.length ? item.name_short : '--'}` }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon @click="() => onEdit(item)" color="primary">mdi-pencil</v-icon>
      </template>
    </v-data-table>
    <PopupEditDebt ref="popup-edit-debt" :item="itemToEdit" @onRefresh="() => onRefresh()" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import { get } from 'lodash'
import PopupEditDebt from './PopupEditDebt.vue'
import SmallSelect from '../../components/samnec/SmallSelect.vue'
import SelectDate from '../../components/basic/SelectDate.vue'
import StatusSelect from '../../components/basic/StatusSelect.vue'

export default {
  name: 'TableListProductModel',
  components: {
    SmallSelect,
    SelectDate,
    PopupEditDebt,
    StatusSelect
  },
  data() {
    return {
      filter: {
        id: '',
        createdAt_lte: null,
        createdAt_gte: null,
        updatedAt_lte: null,
        updatedAt_gte: null,
        autoConfig: null
      },
      page: 1,
      itemsPerPage: 10,
      get,
      itemToEdit: null,
      autoConfigItems: [
        { label: 'Tại thời điểm xuất hóa đơn', value: 'byReleaseDate' },
        { label: 'Tại thời điểm nhận đủ hàng', value: 'byCompleteDate' },
        { label: 'Tuỳ chỉnh', value: 'byCustomDate' }
      ],
      headers: []
    }
  },
  computed: mapState({
    items(state) {
      return state['debtConfig'].items
    },
    loading(state) {
      return state['debtConfig'].loading
    },
    totalCount(state) {
      return state['debtConfig'].count
    },
    headersTheme(state) {
      return state['debtConfig'].themeConfig.headers
    }
  }),
  methods: {
    ...mapActions({
      fetchItems: 'debtConfig/fetchItems',
      countItems: 'debtConfig/countItems',
      getThemeConfig: 'debtConfig/getThemeConfig'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      await this.fetchItems({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.filter
      })
      this.itemsPerPage = itemsPerPage
      this.page = page
    },
    async searchWithOption(val = null) {
      if (val) {
        this.filter.createdAt_gte = get(val, 'createdAt_gte', this.filter.createdAt_gte)
        this.filter.createdAt_lte = get(val, 'createdAt_lte', this.filter.createdAt_lte)
        this.filter.updatedAt_gte = get(val, 'updatedAt_gte', this.filter.updatedAt_gte)
        this.filter.updatedAt_lte = get(val, 'updatedAt_lte', this.filter.updatedAt_lte)
      }
      await this.fetchItems({ _start: 0, _limit: this.itemsPerPage, ...this.filter })
      await this.countItems({ ...this.filter })
    },
    onEdit(data) {
      if (data.id) {
        this.itemToEdit = data
        this.$refs['popup-edit-debt'].openDialog()
      }
    },
    async onRefresh() {
      await this.fetchItems()
      await this.countItems()
      await this.getThemeConfig({ type: 'list' })
    },
    handlerAutoConfig(c) {
      if (!c) return '[Chưa cấu hình]'
      else if (c === 'byCompleteDate') return 'Tại thời điểm nhận đủ hàng'
      else if (c === 'byReleaseDate') return 'Tại thời điểm xuất hóa đơn'
      else if (c === 'byCustomDate') return 'Tuỳ chỉnh'
      else return ''
    }
  },
  async mounted() {
    await this.fetchItems()
    await this.countItems()
    await this.getThemeConfig({ type: 'list' })
    if (this.headersTheme) {
      this.headers = [...this.headersTheme, { text: 'Thao tác', value: 'actions', width: '8%', align: 'center' }]
      this.headers.forEach(h => {
        if (h.value === 'name') h.text = 'NSX'
        if (h.value === 'autoConfig') h.text = 'Cấu hình công nợ'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 8px !important;
  }
}
td,
th {
  padding: 0 8px !important;
}
</style>
